import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  static get values() {
    return {
      frame: String,
      showSourcesDetails: { type: Boolean, default: false },
    }
  }

  toggle() {
    this.showSourcesDetailsValue = !this.showSourcesDetailsValue
    VisitHelper.update(this.frameValue, { show_sources_details: this.showSourcesDetailsValue }, false)
  }
}
